import { c as _c } from "react/compiler-runtime";
import type { InfoMessage } from '@module/types/centrifuge/public-message/upMessageTypes';
interface Props {
  item: InfoMessage;
}
export default function InfoChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  const t0 = `${message.nick}님의 등급이 ${message.name}로 변경되었습니다!`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="mb-[3px] whitespace-pre-wrap text-cht_al_3"><div>{t0}</div></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}